module.exports = __webpack_public_path__ + "img/0-25.5de2645d.jpg";